import { render } from "./CardsPerformance.vue?vue&type=template&id=39d77672&ts=true"
import script from "./CardsPerformance.vue?vue&type=script&lang=ts"
export * from "./CardsPerformance.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__